// @ts-nocheck
export default {
  pt: {
    RESOURCE_CARD_TITLE:
      '#ConquistasCrehana, Porque seu esforço merece um prêmio!',
    RESOURCE_CARD_DESCRIPTION:
      'Cursos gratuitos para que sua educação não pare e aproveite ao máximo seu tempo',
    RESOURCE_CARD_DAY: 'Há {{count}} dia',
    RESOURCE_CARD_DAY_plural: 'Há {{count}} dias',
    RESOURCE_CARD_HOUR: 'Há {{count}} hora',
    RESOURCE_CARD_HOUR_plural: 'Há {{count}} horas',
    RESOURCE_CARD_MINUTE: 'Há {{count}} minuto',
    RESOURCE_CARD_MINUTE_plural: 'Há {{count}} minutos',
    RESOURCE_CARD_SECOND: 'Há {{count}} segundo',
    RESOURCE_CARD_SECOND_plural: 'Há {{count}} segundos',

    BANNER_TITLE: 'Curso livre de hoje',
    BANNER_CONTENT:
      'Nestas {{totalLessons}} aulas aprenda o essencial e o importante para começar o seu caminho para ser o melhor',
    BANNER_CTA: 'Assistir agora',

    COLLAPSE_BAR_1: 'Programe seus cursos livres do mês e',
    COLLAPSE_BAR_2: 'descubra nosso catálogo',

    COURSE_AGENDA_ERROR: 'Um erro ocorreu',
    COURSE_AGENDA_TITLE: 'Agenda de próximos cursos livres',
    COURSE_AGENDA_ENROLL: 'Matricular',
    COURSE_AGENDA_ALREADY_ENROLLED: 'Você já está registrado',

    COURSE_FREE_SIGNUP_TITLE: 'Tenha acesso gratuito a este curso por um dia!',
    COURSE_FREE_SIGNUP_DIALOG_TITLE: 'Matricule-se na Crehana',
    COURSE_FREE_SIGNUP_DIALOG_SUBTITLE: 'E ganhe acesso gratuito ao curso!',
    COURSE_FREE_SIGNUP_WITH: 'Cadastre-se com',
    COURSE_FREE_SIGNUP_CUSTOM_TITLE: 'Inscreva-se gratuitamente',
    COURSE_FREE_SIGNUP_HAVE_ACCOUNT: 'Você tem uma conta?',
    COURSE_FREE_SIGNUP_LOGIN: 'Conecte-se',

    COURSE_FREE_TITLE: 'Curso livre de hoje',
    COURSE_FREE_SEE_MORE: 'Ver mais cursos',
    COURSE_FREE_STAT_STUDENTS: '{{count}} Alunos',
    COURSE_FREE_STAT_COURSE_LEVEL: 'Curso {{level}}',

    ENROLLMENT_DIALOG_TITLE: 'Obrigado por inscrever-se!',
    ENROLLMENT_DIALOG_DESCRIPTION:
      'Enviaremos um e-mail quando o curso for liberado.',
    ENROLLMENT_DIALOG_CLOSE: 'Entendi',

    FEATURES_TITLE_1: 'Um curso gratuito por dia',
    FEATURES_DESCRIPTION_1: 'disponível por 24 horas.',
    FEATURES_TITLE_2: 'Upload de projetos',
    FEATURES_DESCRIPTION_2: 'habilitado por 24 horas.',
    FEATURES_TITLE_3: 'Certificado de participação',
    FEATURES_DESCRIPTION_3: 'por suas horas de esforço.',

    LIVE_BANNER_TITLE: 'Crehana Live: Conheça nossas próximas aulas ao vivo',
    LIVE_BANNER_CTA: 'Conheça crehana lives',

    REGISTER_BAR_TITLE: 'Matricule-se na Crehana',
    REGISTER_BAR_EMAIL: 'E-mail',
    REGISTER_BAR_EMAIL_ERROR: 'Por favor insira um endereço de e-mail válido',
    REGISTER_BAR_PASSWORD: 'Senha',
    REGISTER_BAR_REQUIRED_FIELD: 'Campo obrigatório',
    REGISTER_BAR_SUBMIT: 'Cadastre-se',

    CARD_LEAD_TITLE: 'Aprenda sem limites',
    CARD_LEAD_COPY:
      'Está perto de acessar o melhor desconto em 500 cursos, mentorias, especializações e mais.',
    CARD_LEAD_CTA: 'Vamos conversar',

    EXIT_POPUP_TITLE: 'Espere! Você tem um teste grátis',
    EXIT_POPUP_SUB_TITLE:
      'Descubra nossa assinatura com acesso a todos os cursos por 24 horas',
    EXIT_POPUP_CTA: 'Experimente Agora',
  },
};
